// Lodge Config Actions

import LodgeApiClient from '../../../api/clients/LodgeApiClient';
import { LODGE_CONFIG_TYPES } from '../../../utilities/constants';
import { updateCurrentLodge } from '../CurrentLodge/currentLodge.actions';
import { getResortLocation } from '../CurrentLodge/currentLodge.selectors';
import lodgeConfigActionTypes from './lodgeConfig.types';

const verifyIfIsEnabled = option => {
  const optionValue = typeof option === 'boolean' ? option : false;
  return optionValue;
};

const verifyPointsMultiplier = option => {
  const optionValue = typeof option === 'number' ? option / 100 : 0.1;
  return optionValue;
};

const transformStringToArray = option => JSON.parse(option);

export const getBeIdMeParameters = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(
      resortLocation,
      LODGE_CONFIG_TYPES.IDME_WIDGET
    );
    dispatch({
      type: lodgeConfigActionTypes.ID_ME_DATA_PARAMETERS,
      idMeParameters: configurationData.data
    });
  } catch (error) {
    console.log(error);
  }
};

export const getDaypassConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.DAYPASS);
    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_DAYPASS,
      daypassTicketLimit: configurationData.data.daypassTicketLimit
    });
  } catch (error) {
    console.log(error);
  }
};

export const getLoyaltyConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.LOYALTY);

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING,
      isLoyaltyEnabled: verifyIfIsEnabled(configurationData.data.isLoyaltyEnabled),
      isInPrimerState: verifyIfIsEnabled(configurationData.data.isInPrimerState),
      isOffersEnabled: verifyIfIsEnabled(configurationData.data.isOffersEnabled),
      loyaltyPointsMultiplier: verifyPointsMultiplier(configurationData.data.loyaltyPointsMultiplier),
      isLoyaltyReferralEnabled: verifyIfIsEnabled(configurationData.data.isLoyaltyReferralEnabled),
      isLoyaltyPointsExpirationOnProfileEnabled: verifyIfIsEnabled(
        configurationData.data.isLoyaltyPointsExpirationOnProfileEnabled
      ),
      loyaltyPointsToEarn: configurationData.data.loyaltyPointsToEarn,
      loyaltyEarnThresholdNights: configurationData.data.loyaltyEarnThresholdNights ?? 2,
      //TODO: This flag will be here until we find a proper lodge config API to hold this case
      isHoldCancelReservationEnabled: verifyIfIsEnabled(configurationData.data.isHoldCancelReservationEnabled)
    });
  } catch (error) {
    console.log(error);
  }
};
export const getPlanConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.PLAN);

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_PLAN,
      config: {
        additionalPersonAmount: configurationData.data.additionalPersonAmount,
        affirmPubKey: configurationData.data.affirmPubKey,
        filters: configurationData.data.filters,
        isFetchRestrictionsEnabled: configurationData.data.isFetchRestrictionsEnabled,
        isHighestRatesEnabled: configurationData.data.isHighestRatesEnabled,
        isRateCalEnabled: configurationData.data.isRateCalEnabled,
        updateSearchFullPageRefresh: configurationData.data.updateSearchFullPageRefresh,
        includeResortFeeInSuitePrice: configurationData.data.includeResortFeeInSuitePrice,
        pricePerWaterPass: configurationData.data.pricePerWaterPass,
        isRoomUnbundledRateWPAvailable: configurationData.data.isRoomUnbundledRateWPAvailable,
        suitePriceIncludedTaxesAndFees: configurationData.data.suitePriceIncludedTaxesAndFees ?? [],
        showDiningPageInUFFFlow: configurationData.data.showDiningPageInUFFFlow,
        showResortFeeModal: configurationData.data.showResortFeeModal,
        showHighlightBadge: verifyIfIsEnabled(configurationData.data.showHighlightBadge),
        suiteCardVersionKEnabled: verifyIfIsEnabled(configurationData.data.suiteCardVersionKEnabled),
        enableMemberRates: verifyIfIsEnabled(configurationData.data.enableMemberRates),
        isTaxOnlyMessage: verifyIfIsEnabled(configurationData.data.isTaxOnlyMessage),
        promosForShortMessaging: transformStringToArray(configurationData.data.promosForShortMessaging),
        isSleepUpToCase: verifyIfIsEnabled(configurationData.data.isSleepUpToCase),
        lowestToHighestAttractionPasses: configurationData.data.lowestToHighestAttractionPasses,
        taxesExcluded: verifyIfIsEnabled(configurationData.data.taxesExcluded),
        fareFamilyV2only: verifyIfIsEnabled(configurationData.data.fareFamilyV2only)
      }
    });
  } catch (error) {
    console.log(error);
  }
};
export const getUserSettingsByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(
      resortLocation,
      LODGE_CONFIG_TYPES.USER_SETTINGS
    );

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_USER_SETTINGS,
      newPatchEndpoint: configurationData.data['new-patch-endpoint']
    });
  } catch (error) {
    console.log(error);
  }
};
export const getCreditPackageConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(
      resortLocation,
      LODGE_CONFIG_TYPES.CREDIT_PACKAGES
    );

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_CREDIT_PACKAGE,
      isDiningPackagesEnhancedUIEnabled: verifyIfIsEnabled(configurationData.data.isDiningPackagesEnhancedUIEnabled),
      showAdventurePassesBeforeAttractionPassesInPreCheckInFlow: verifyIfIsEnabled(
        configurationData.data.showAdventurePassesBeforeAttractionPassesInPreCheckInFlow
      )
    });
  } catch (error) {
    console.log(error);
  }
};
export const getCmpConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.CMP);

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_CMP,
      isDynamicTileEnabled: verifyIfIsEnabled(configurationData.data.isDynamicTileEnabled),
      hideOnlineCheckinText: verifyIfIsEnabled(configurationData.data.hideOnlineCheckinText),
      parkingFeeCallout: verifyIfIsEnabled(configurationData.data?.parkingFeeCallout),
      parkingFeeCalloutTitle: configurationData.data?.parkingFeeCalloutTitle ?? '',
      parkingFeeCalloutDescription: configurationData.data?.parkingFeeCalloutDescription ?? '',
      uffTileEnabled: verifyIfIsEnabled(configurationData.data.uffTileEnabled),
      isCancelReservationEnabled: verifyIfIsEnabled(configurationData.data.isCancelReservationEnabled),
      showPackagesInAddGuestsModal: verifyIfIsEnabled(configurationData.data.showPackagesInAddGuestsModal),
      isManageYourReservationEnabled: verifyIfIsEnabled(configurationData.data.isManageYourReservationEnabled),
      isAddGuestsEnabled: verifyIfIsEnabled(configurationData.data.isAddGuestsEnabled),
      isChangeDatesEnabled: verifyIfIsEnabled(configurationData.data.isChangeDatesEnabled),
      isStaticDaypassEnabled: verifyIfIsEnabled(configurationData.data.isStaticDaypassEnabled),
      isAddGuestAPS: verifyIfIsEnabled(configurationData.data.isAddGuestAPS),
      lowestToHighestAttractionPasses: configurationData.data.lowestToHighestAttractionPasses
    });
  } catch (error) {
    console.log(error);
  }
};
/* ABCD TEST FOR PARKING FEE */
export const getPaymentConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.PAYMENT);

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_PAYMENT,
      perNightParkingFee1: configurationData.data.perNightParkingFee1,
      perNightParkingFee2: configurationData.data.perNightParkingFee2,
      perNightParkingFee3: configurationData.data.perNightParkingFee3,
      parkingFeeStartDate: configurationData.data.parkingFeeStartDate,
      parkingFeeEndDate: configurationData.data.parkingFeeEndDate,
      creditCardAuthUrl: configurationData.data.creditCardAuthUrl,
      creditEnabled: configurationData.data.creditEnabled,
      affirmEnabled: configurationData.data.affirmEnabled,
      applePayEnabled: configurationData.data.applePayEnabled,
      googlePayEnabled: configurationData.data.googlePayEnabled,
      payPalEnabled: configurationData.data.payPalEnabled,
      isIFrameEnabled: configurationData.data.isIFrameEnabled,
      amexEnabled: verifyIfIsEnabled(configurationData.data?.isAmexEnabled),
      bookingSummaryParkingFee: configurationData.data?.bookingSummaryParkingFee,
      taxAndFeeLabels: configurationData.data?.taxAndFeeLabels
    });
  } catch (error) {
    console.log(error);
  }
};
/* ABCD TEST FOR PARKING FEE */
export const getLeadGenConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.LEAD_GEN);

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_LEADGEN,
      shouldLeadGenPop: configurationData.data.shouldLeadGenPop
    });
  } catch (error) {
    console.log(error);
  }
};
export const resetLodgeConfig = () => async dispatch => {
  dispatch(updateCurrentLodge());
  dispatch({ type: lodgeConfigActionTypes.RESET_LODGE_CONFIG });
};
export const getCartConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.CART);

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_CART,
      config: {
        isCartActive: configurationData.data.isCartActive
      }
    });
  } catch (error) {
    console.log(error);
  }
};
export const getBookingWidgetConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(
      resortLocation,
      LODGE_CONFIG_TYPES.BOOKING_WIDGET
    );

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_BOOKING_WIDGET,
      beginReservationsDate: configurationData.data.beginReservationsDate,
      maxOccupancy: configurationData.data.maxOccupancy,
      stickyBottomBookingWidget: verifyIfIsEnabled(configurationData.data.stickyBottomBookingWidget),
      ageThreshold: configurationData.data.ageThreshold,
      isLowestRatesRestrictionsEnabled: verifyIfIsEnabled(configurationData.data.isLowestRatesRestrictionsEnabled),
      // THIS IS A TEMP FLAG FOR SYNCING UFF REDESIGN CHANGES, #72251 - #78260 - #78261
      // TO BE DELETED ON RELEASE
      tempUffRedesignActive: verifyIfIsEnabled(configurationData.data.tempUffRedesignActive),
      // THIS IS A TEMP FLAG FOR SYNCING UFF REDESIGN CHANGES, #72251 - #78260 - #78261
      // TO BE DELETED ON RELEASE
      hiddenOfferPrefixes: transformStringToArray(configurationData.data.hiddenOfferPrefixes)
    });
  } catch (error) {
    console.log(error);
  }
};

export const getPartyBookingWidgetConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(
      resortLocation,
      LODGE_CONFIG_TYPES.BDAY_BOOKING_WIDGET
    );

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_PARTY_BOOKING_WIDGET,
      isBdayBookingWidgetActive: configurationData.data.isBdayBookingWidgetActive,
      birthdayPartyInclusionList: transformStringToArray(configurationData.data.birthdayPartyInclusionList) ?? [],
      partyKidsPerAdultRatio: configurationData.data.kidsPerAdultRatio,
      partyMaxGuestCount: configurationData.data.maxGuestCount,
      minimumBookingDaysRestriction: configurationData.data.minimumBookingDaysRestriction,
      maximumBookingDaysRestriction: configurationData.data.maximumBookingDaysRestriction,
      maxSpectatorsCount: configurationData.data.maxSpectatorsCount ?? 5
    });
  } catch (error) {
    console.log(error);
  }
};

export const getProfilePageConfigResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.PROFILE);

    if (configurationData?.data?.maxSpectatorsCount) {
      dispatch({
        type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_PROFILE,
        packMembersLimit: configurationData.data.maxSpectatorsCount
      });
    }
  } catch (error) {
    console.log(error);
  }
};
